import {
  eachDayOfInterval, eachHourOfInterval, eachWeekOfInterval, eachMonthOfInterval,
  format, parseISO,
} from 'date-fns';
import type { Granularity } from './metrics';

export function autoGranularity(rangeDays: number): Granularity {
  if (rangeDays < 1)   return 'hour';
  if (rangeDays <= 90) return 'day';
  if (rangeDays <= 365) return 'week';
  return 'month';
}

export interface SparseBucket {
  bucket_date: string;
  current: number;
  previous: number | null;
  segment?: string;
}

const KEY_FORMAT: Record<Granularity, string> = {
  hour: "yyyy-MM-dd'T'HH",
  day: 'yyyy-MM-dd',
  week: 'yyyy-MM-dd',
  month: 'yyyy-MM-dd',
};

export function bucketKeyFormat(g: Granularity): string {
  return KEY_FORMAT[g];
}

export function zeroFillBuckets(
  buckets: SparseBucket[],
  from: Date,
  to: Date,
  granularity: Granularity,
): SparseBucket[] {
  const interval = { start: from, end: to };
  const dates = granularity === 'hour'
    ? eachHourOfInterval(interval)
    : granularity === 'day'
      ? eachDayOfInterval(interval)
      : granularity === 'week'
        ? eachWeekOfInterval(interval, { weekStartsOn: 1 })
        : eachMonthOfInterval(interval);

  const keyFormat = KEY_FORMAT[granularity];
  const map = new Map(buckets.map(b => [b.bucket_date, b]));
  return dates.map(d => {
    const key = format(d, keyFormat);
    return map.get(key) ?? { bucket_date: key, current: 0, previous: null };
  });
}

export function formatBucketTick(bucket: string, granularity: Granularity): string {
  const d = parseISO(bucket);
  switch (granularity) {
    case 'hour':  return format(d, 'HH:mm');
    case 'day':   return format(d, 'MMM d');
    case 'week':  return format(d, "'W'w");
    case 'month': return format(d, 'MMM');
  }
}
